import {BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, MuiDataGrid, MuiIcons} from "@leap4/frontend";
import {GroupsBaseUrl} from "../../../../config/generals";
import {urlService} from "../../../routing/urlsService";
import {Link} from "react-router-dom";
import {RootState} from "../../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";

const { Groups: GroupsIcon } = MuiIcons;
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;
const fields = {
    name: 1,
    method: 1,
}

const populate = [{path: "method"}];
const getParams: IGetAllParams = {
    fields,
    populate
}
let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${GroupsBaseUrl}`
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.editGroup(id)},
        isActive: {},
        updated: {},
        created: {}
    })
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

    const nameCol = columns.find(x => x.field === "name");
    nameCol.renderCell = (params: GridRenderCellParams) =>
        <Link to={urlService.editGroup(params.id.toString())}><strong
        >{params.value}</strong></Link>

    const methodCol = columns.find(x => x.field === "method");
    methodCol.renderCell = (params: GridRenderCellParams) => params.value
}
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});



const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const GroupsDashboardModule = (props:PropsFromRedux) => {
    setStoreAndColumns();

    return (
            <GenericItemsForm
                organization={props.selectedOrganization}
                columns={columns}
                store={store}
                breadcrumbs={{
                    link: urlService.groups(),
                    text: "Groups Dashboard",
                    icon: <GroupsIcon />
                }}
                tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
                getAllParams={getParams}
                createButton={{
                    text: "Create Group",
                    to: urlService.createGroup()
                }
                }
            />
    );
};

export default connector(GroupsDashboardModule);